import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePageURL } from "../assets/const";
import TargetList from "../pages/target/TargetList";
import TargetDetail from "../pages/target/TargetDetail";

const TargetRoute = () => {
  return (
    <Routes>
      <Route path={`${HomePageURL}/targets/`} element={<TargetList />} />
      <Route
        path={`${HomePageURL}/targets/:targetId/`}
        element={<TargetDetail />}
      />
    </Routes>
  );
};

export default TargetRoute;
